const maintenance = {
  on: "iizenglish is currently undergoing maintenance and will be back in a few minutes.",
  details: "Please refresh the page in a few moments.",
  futureUpdateBannerMsg:
    "iizenglish will be updated on {date} and will be unavailable for a few minutes.",
};

export default maintenance;
